<template>
	<div>
		<v-img
			contain
			:width="width"
			:height="height"
			:src="getThumbnailUrl()"
			@click="openCadDialog()"
			title="Cad öffnen"
			style="cursor: pointer"
		></v-img>
		<v-dialog v-if="cadDialog" v-model="cadDialog" content-class="specialSize" persistent>
			<div style="background-color: #f3f3f4; padding: 0px; margin 0px">
				<iframe
					v-if="cadDialog"
					loading="lazy"
					:height="currentWindowHeight"
					:src="articleCadViewUrl"
					style="padding: 0px; margin: 0px; border: 0px; width: 100%"
				>
				</iframe>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import httpClient from "../store/httpClient";
export default {
	props: {
		articleId: 0,
		width: "",
		height: "",
		readonly: false,
	},
	data() {
		return {
			cadDialog: false,
			articleHasUnsavedChanges: false,
			currentWindowHeight: "100px",
			articleToken: null,
		};
	},
	mounted() {
		this.setWindowHeight();
		window.addEventListener("resize", (event) => {
			this.setWindowHeight();
		});
	},

	methods: {
		getThumbnailUrl() {
			return `${process.env.VUE_APP_erpUrl}article/getthumbnail?id=${this.articleId}&time=${this.articleLastChange}`;
		},
		setWindowHeight() {
			// 165 besteht aus...
			// - Margins der Dialogbox (variieren etwas je nach Aspect Ratio)
			// - Buttons für Speichern / Schliessen im Dialogfenster
			// - Sicherheitsmarge, sodass sicher keine Scrollbar im Dialog erscheint
			const currentHeight = window.innerHeight - 65;
			this.currentWindowHeight = `${currentHeight}px`;
		},
		async openCadDialog() {
			if (!this.cadDialog) {
				try {
					const response = await httpClient().get(
						`api/artikel/GetArticleToken?blexonArtikelId=${this.articleId}&isWritable=${!this.readonly}`
					);
					this.articleToken = response.data;
					if (this.articleToken != null) {
						window.addEventListener("message", this.handleArticleChangedInCad);
						this.cadDialog = true;
					}
				} catch (err) {
					console.log(`Für den Artikel konnte kein Token geladen werden. Error: ${err}`);
				}
			} else {
				this.cadDialog = false;
			}
		},

		/**
		 * This event handler is called, when the cad article in the iframe has changed.
		 */
		async handleArticleChangedInCad(event) {
			if (
				event.origin == "https://cad.test.blexon.com" ||
				event.origin == "https://cad.blexon.com" ||
				event.origin == "https://cam.blexon.com" ||
				event.origin == "https://cam.test.blexon.com" ||
				event.origin == "http://localhost:8180" ||
				event.origin == "http://localhost:8185"
			) {
				await this.closeCadDialog();
			}
		},

		async closeCadDialog() {
			window.removeEventListener("message", this.handleArticleChangedInCad);
			await httpClient().post(`api/artikel/DeleteToken?token=${this.articleToken.token}`);
			this.articleToken = null;
			this.cadDialog = false;
		},
	},
	computed: {
		articleCadViewUrl() {
			let localToken = "";
			if (this.articleToken !== null) {
				localToken = this.articleToken.token;
			}
			return `${process.env.VUE_APP_CAM_CLIENT_URL}${this.articleId}/${localToken}`;
		},
	},
};
</script>
